export default {
  en: {
    title: 'Calendars',
    subtitle: 'List of calendars will be visible by your customers.',
  },
  es: {
    title: 'Calendarios',
    subtitle: 'Listado de calendarios disponibles para tus clientes.',
  },
  fr: {
    title: 'Calendriers',
    subtitle: 'Liste des calendriers disponibles pour vos clients.',
}

};
